export const LOCATION_CLICK = "SS_LOCATION_CLICK";
export const SET_ACTIVE_LOCATION = "SS_SET_ACTIVE_LOCATION";
export const LOCATION_SWIPE_RIGHT = "SS_LOCATION_SWIPE_RIGHT";
export const LOCATION_SWIPE_LEFT = "SS_LOCATION_SWIPE_LEFT";
export const TOGGLE_MAP_VIEW = "SS_TOGGLE_MAP_VIEW";
export const CLOSE_ZOOM = "SS_CLOSE_ZOOM";
export const TOGGLE_SETTINGS = "TOGGLE_SERVICECENTERS_SETTINGS";
export const GET_LOCATIONS = "GET_LOCATIONS";
export const RESET_STATE = "RESET_SERVICE_CENTERS_STATE";
